<template>
  <div id="app">
    <suspense>
      <router-view />
    </suspense>
    <div id="message-box"></div>

    <div id="mloading" class="loading">
      <div class="loading-cover"></div>
      <div class="loading-svg">
        <div class="effect-1 effects"></div>
      </div>
    </div>
    <modals-container></modals-container>

    <div id="misa-ava-auto-notification"></div>

    <dialog-wrapper />
    <div class="fake-click"></div>

    <!-- Begin các tính năng phía bên phải màn hình -->
    <div
      class="tool-feature-container right"
      :style="{
        left: positionTransfrom.left == 'unset' ? positionTransfrom.left : positionTransfrom.left + 'vw',
        top: positionTransfrom.top == 'unset' ? positionTransfrom.top : positionTransfrom.top + 'vh',
        right: positionTransfrom.right == 'unset' ? positionTransfrom.right : positionTransfrom.right + 'vw',
        bottom: positionTransfrom.bottom == 'unset' ? positionTransfrom.bottom : positionTransfrom.bottom + 'vh',
      }"
      :class="[{hovered: isHovered},{ishidden: IsPressChatbot}]"
      @mousemove="startDrag"
      @mousedown="handleMouseDown"
      @mouseup="handleMouseUp"
    >
      <div id="amis-support" ></div>  
      <div id="new-feature"></div>
      <div id="help-settlemen-quick"></div>
      <div id="ava-chat-bot"></div>
       <div id="misa-community-chat"></div>
    </div>
    <!-- End các tính năng phía bên phải màn hình -->
  </div>
</template>

<script>
import {DialogWrapper} from 'vue3-promise-dialog';
import {ModuleContext} from '@/stores/moduleConst';
import commonFn from '@/commons/commonFunction';
import {useStore} from 'vuex';
import popupUtil from '@/commons/popupUtil';
import ToolsFeatureButton from '@/views/toolFeature/ToolsFeatureButton.vue';
import {mapGetters} from 'vuex';
import applicationVersion from '@/apis/proxy/versionApplicationApi.js';
export default {
  mixins: [ToolsFeatureButton],
  components: {
    DialogWrapper,
  },
  data() {},
  computed: {
    ...mapGetters({
      IsPressChatbot: ModuleContext + '/IsPressChatbot',
    }),

    useLiveChat() {
      return window?.useLiveChat;
    },
  },

  watch: {},
  created() {},

  mounted() {
    const me = this;
    me.initEnterSameTab();
    // trường hợp license hết hạn
    if (commonFn.checkRouterExpiredDate()) {
      return;
    }
    // trường hợp license sắp hết hạn
    const store = useStore();
    const {Context} = store.state[ModuleContext];
    if (Context?.ShowWarningDate) {
      popupUtil.show('ExpireWarning');
    }

    window.addEventListener(
      'popstate',
      function (event) {
        if (!Context?.DatabaseId) {
          // logout
          commonFn.logoff();
        }
      },
      false,
    );
    // Kiểm tra xem có lệch db id không
    if(window._checkDifferenceDatabaseID){
      try {
        if(Context?.DatabaseId && window._dbid && window._dbid !== me.$ms.constant.FixValue.GuidEmpty && Context?.DatabaseId !== window._dbid){            
        // Set cờ để reload
        window._appConfig.differenceDatabaseID = true;      
        // Gọi đến BE để ghi log
        applicationVersion.logDatabaseIDAsync(`${Context.DatabaseId}`, `${window._dbid}`, `${Context.UserID}`, `${Context.TenantId}`);
      }
      } catch (error) {
       console.log(error); 
      }
    }    
  },
  methods: {
    /**
     * next control khi ấn Enter
     */
    initEnterSameTab() {
      const me = this;

      window.addEventListener('keydown', function (e) {
        if (e.which === 13 && !e.shiftKey) {
          let tag = e.target.tagName.toLowerCase();
          if (['button', 'a'].indexOf(tag) > -1) {
            return;
          }

          if ('textarea' == tag && e.shiftKey) {
            return;
          }
          //Nếu sự kiện xảy ra ở grid thì không bắt sự kiện ở hàm này nữa. Trong grid đã xử lý.
          //Thêm kiểm tra phải là control nhập liệu trong bođy thì mới bỏ qua
          if (e.target.closest('.ms-grid-viewer') && e.target.closest('tbody')) {
            return;
          }
          //ntphong 27/5/2021 - với control có class remain-focus-when-enter thì không focus sang control tiếp theo khi ấn enter
          if (e.target.closest('.remain-focus-when-enter')) {
            return;
          }
          let focusable = me.$ms.commonFn.focusNextControl(e.target);
          if (focusable) {
            e.preventDefault();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
  .ishidden{
    display :none;
  }
</style>